import React, { useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import AddExpenseModal from "./AddExpenseModal";
import ExpenseOverviewTable from "./ExpenseOverviewTable";

const ExpenseOverview = () => {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("add"); 
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleAdd = () => {
    setMode("add");
    setSelectedExpense(null);
    setOpen(true);
  };

  const handleEdit = (expense) => {
    setMode("edit");
    setSelectedExpense(expense);
    setOpen(true);
  };

  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="h4" fontWeight={700} sx={{ fontSize: "32px" }}>
            Expense Overview
          </Typography>
          <Typography sx={{ fontSize: "14px", marginTop: "4px" }} color="text.secondary">
            Manage and track all your expenses
          </Typography>
        </Box>

        <Button
          onClick={handleAdd}
          sx={{
            background: "#BE1F1F",
            fontSize: "16px",
            px: 2,
            fontWeight: "500",
            color: "#fff",
            textTransform: "capitalize",
            '&:hover': { background: '#FF4A4A' },
          }}
        >
          Add Expense
        </Button>
      </Stack>

      <ExpenseOverviewTable onEdit={handleEdit} refreshKey={refreshKey}/>

      <AddExpenseModal
        open={open}
        handleClose={() => setOpen(false)}
        mode={mode}
        selectedExpense={selectedExpense}
       onSuccess={() => setRefreshKey(prev => prev + 1)}
      />
    </>
  );
};

export default ExpenseOverview;
